import React from 'react'
import { useRecoilState } from 'recoil'

import fontSizeAtom, { defaultFontSize } from 'store/fontSize'

export function useFontSize() {
  const [isInitial, setIsInitial] = React.useState(true)
  const [fontSize, setFontSize] = useRecoilState(fontSizeAtom)

  React.useEffect(() => {
    setIsInitial(false)
  }, [])

  return [isInitial === true ? defaultFontSize : fontSize, setFontSize] as const
}
